module.exports = __webpack_public_path__ + "img/millfields_rd_b9.508697e0.jpg";